export class Juridica {
  constructor() {
    this.id = 0;
    this.cnpj = '';
    this.razaoSocial = '';
    this.ie = '';
    this.im = '';
    this.cnae = '';
    this.crt = '';
  }

  validarCnpj() {
    return true;
  }
}
